// import clone from 'clone';
import actions from './actions';
const initState = {  
  usergroups:[],
  usergroup:{},
  isDelete:false,
  isSaved:false,
  isLoading: false,
};

export default function cardReducer(state = initState, { type, ...action }) {
  switch (type) {
    case actions.ADD_USERGROUP_SUCCESS:
      return {
        ...state,             
        usergroups: [],    
        isLoading: false,
        isDelete:false,
        isSaved:true  
      };
    case actions.GET_USERGROUP_REDUCER: {
      return {
        ...state,
        usergroups: action.usergroups,      
        isLoading: true,
        isDelete:false,
        isSaved:false
      };
    }
    case actions.GET_GROUP_BY_ID_REDUCER: {
      return {
        ...state,
        usergroup: action.data,  
        isLoading: true,
        isDelete:false,
        isSaved:false 
      };
    }
    case actions.DELETE_USER_GROUP_SUCCESS:
      return {
        ...state, 
        isLoading: false,      
        isDelete:true
      };  
    default:
      return state;
  }
}
